export default "__VITE_ASSET__WsWlczy1__"